import PropTypes from 'prop-types';
import { seatMap } from '@eti/products';
import { useProperty, useTranslation } from '@eti/providers';
import { useScrollTo } from '@eti/utils';
import { scrollToElement } from '../../../../utils/scrollToElement';
import ReviewModalSection from './ReviewModalSection';
import ReviewProductItem from './ReviewProductItem';

const ReviewModalSelectedExtraProducts = ({ selectedProducts, setShowReviewModal }) => {
  const { p } = useProperty();
  const { t } = useTranslation();
  const { scrollVertical } = useScrollTo();

  const scrollToTop = () => scrollVertical('smooth', 0);
  const handleEditExtraProducts = () => {
    setShowReviewModal(false);
    if (p('TravelerDetails.DynamicFlow.Enabled')) {
      scrollToTop();
    } else {
      scrollToElement('[data-testid="traveler-details-extra-product-0"]');
    }
  };

  return (
    <>
      <ReviewModalSection
        button={{
          onClick: handleEditExtraProducts,
          testId: 'travelerDetails-reviewModal-extraProducts-edit',
          text: t('TravelerDetails.Review.Modal.ExtraProducts.Selected.Edit.Label'),
        }}
        dataTestId="travelerDetails-reviewModal-selectedExtraProducts-section"
        subtitle={t('TravelerDetails.Review.Modal.ExtraProducts.Selected.Header.Text')}
        title={t('TravelerDetails.Review.Modal.ExtraProducts.Selected.Header.Label')}
      >
        {selectedProducts
          .filter((product) => product.id !== seatMap.id)
          .map((product) => (
            <ReviewProductItem id={product.name} key={product.name} title={product.title} />
          ))}
      </ReviewModalSection>
    </>
  );
};

ReviewModalSelectedExtraProducts.propTypes = {
  selectedProducts: PropTypes.arrayOf(PropTypes.any),
  setShowReviewModal: PropTypes.func,
};

export default ReviewModalSelectedExtraProducts;
